/*
  assets/littleg-result-card-runtime.js — LITTLEG-RESULT-CARD-LOCALE-RUNTIME-04
  Updated: 2026-09-10

  Owner: Screen 06 result-card hydration and Explore Screen 01/08 official-data projection.
  Locale source: Liquid-rendered data attributes on component roots.
  Persistence dependency: public window.LittleGResultStorage.saveLocalizedResult().
  Explore routing dependency: assets/littleg-daily-mission-flow.js remains the only screen
  navigate()/activate() owner; this file only asks an existing data-lg-screen-link to navigate.
  Boundary: no storage-key authority, global navigation ownership, backend mutation, GFun write,
  checkout, formal report, paid Places API or fabricated place fields.
*/
(function littleGResultCardRuntime(window, document) {
  'use strict';

  var VERSION = 'LITTLEG-RESULT-CARD-LOCALE-RUNTIME-04';
  var ROOT_SELECTOR = '[data-littleg-result-card]';

  if (window.__LITTLEG_RESULT_CARD_LOCALE_RUNTIME__ === VERSION) return;
  window.__LITTLEG_RESULT_CARD_LOCALE_RUNTIME__ = VERSION;

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }

  function canonicalLane(value) {
    var raw = clean(value);
    if (!raw) return '';
    if (window.GCityPartnersServiceLaneMap && typeof window.GCityPartnersServiceLaneMap.canonical === 'function') {
      return window.GCityPartnersServiceLaneMap.canonical(raw) || raw;
    }
    return raw;
  }

  function attr(card, name, fallback) {
    return clean(card.getAttribute(name)) || clean(fallback);
  }

  function setText(card, selector, value) {
    var node = qs(selector, card);
    if (node && clean(value)) node.textContent = String(value);
  }

  function setField(card, name, value) {
    setText(card, '[data-memory-field="' + name + '"]', value);
  }

  function ownAction(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  function toArray(value) {
    if (!value) return [];
    var list = [];
    if (Array.isArray(value)) list = value;
    else if (Array.isArray(value.clues)) list = value.clues;
    else if (Array.isArray(value.items)) list = value.items;
    else if (typeof value === 'string') list = value.split(/[|,]/);
    return list.map(clean).filter(Boolean);
  }

  function state(card) {
    return card.__littleGMissionState && typeof card.__littleGMissionState === 'object'
      ? card.__littleGMissionState
      : {};
  }

  function announce(card, runtimeState, message) {
    card.setAttribute('data-result-card-runtime-state', runtimeState);
    var node = qs('[data-result-card-status]', card);
    if (node) node.textContent = clean(message);
  }

  function hydrate(card) {
    if (!card) return;

    var current = state(card);
    var cityLabel = attr(card, 'data-city-label', 'Hong Kong');
    var place = clean(current.location || current.place_label) || attr(card, 'data-place-label', cityLabel);
    var hero = clean(current.hero || current.hero_type || current.mission_name || current.title);
    var scene = clean(current.formal_category || current.formalCategory || current.scene_label || current.life_category);
    var clues = toArray(current.clues || current.selected_clue_labels || current.selectedClueLabels).slice(0, 3);
    var memory = clean(current.city_pain || current.memory_note || current.life_pain);
    var direction = clean(current.renewal_clue || current.plus001_direction);
    var summary = clean(current.source_line || current.informal_summary);
    var lane = canonicalLane(current.scene_key || current.next_step_service_lane || current.service_lane);
    var shareText = clean(current.share_text) || attr(card, 'data-social-share-text', 'LittleG');

    if (hero) {
      setText(card, '[data-finish-title]', attr(card, 'data-title-prefix', '') + hero);
      setField(card, 'today_diary', attr(card, 'data-diary-prefix', '') + hero + attr(card, 'data-diary-suffix', ''));
    }
    if (scene) setField(card, 'scene_label', scene);
    if (memory) setField(card, 'memory_note', memory);
    if (direction) setField(card, 'plus001_direction', direction);
    if (summary) setField(card, 'informal_summary', summary);
    if (lane) setField(card, 'next_step_service_lane', lane + attr(card, 'data-next-step-suffix', ''));

    setText(card, '[data-finish-social-line]', shareText);
    setText(
      card,
      '[data-finish-card-lines]',
      clues.length
        ? attr(card, 'data-clues-prefix', '') + clues.join(attr(card, 'data-clues-separator', '、'))
        : attr(card, 'data-card-lines-empty', '')
    );

    qsa('[data-lead-place]', card).forEach(function (node) {
      node.textContent = place;
    });
    setText(card, '[data-memory-place]', place);
    setField(card, 'place_label', place);

    clues.forEach(function (clue, index) {
      setText(card, '[data-clue-item="' + index + '"] strong', clue);
    });

    card.setAttribute('data-social-share-text', shareText);
    card.setAttribute('aria-hidden', card.hidden ? 'true' : 'false');
    qsa('[data-share-mission-card], [data-copy-challenge]', card).forEach(function (button) {
      button.disabled = !shareText;
      button.setAttribute('aria-disabled', shareText ? 'false' : 'true');
    });
  }

  function identityFromState(card) {
    var current = state(card);
    var id = clean(current.result_id || current.record_id || current.card_id || current.id);
    return {
      result_id: id,
      record_id: id,
      card_id: id,
      story_id: clean(current.story_id || current.round_key),
      round_key: clean(current.round_key || current.story_id),
      daily_scene_id: clean(current.daily_scene_id || current.mission_handle),
      mission_handle: clean(current.mission_handle || current.daily_scene_id),
      mission_name: clean(current.mission_name || current.title),
      created_at: clean(current.created_at || current.completed_at)
    };
  }

  function payloadFromCard(card) {
    return Object.assign(identityFromState(card), {
      source: 'littleg-game-lobby',
      locale: attr(card, 'data-city-locale', 'zh-TW'),
      city_pack_id: attr(card, 'data-city-pack-id', 'hk'),
      city: attr(card, 'data-city', 'hong-kong'),
      district: attr(card, 'data-district', 'hong-kong'),
      place_label: clean((qs('[data-memory-field="place_label"]', card) || {}).textContent),
      scene_label: clean((qs('[data-memory-field="scene_label"]', card) || {}).textContent),
      today_diary: clean((qs('[data-memory-field="today_diary"]', card) || {}).textContent),
      memory_note: clean((qs('[data-memory-field="memory_note"]', card) || {}).textContent),
      plus001_direction: clean((qs('[data-memory-field="plus001_direction"]', card) || {}).textContent),
      informal_summary: clean((qs('[data-memory-field="informal_summary"]', card) || {}).textContent),
      next_step_service_lane: canonicalLane((qs('[data-memory-field="next_step_service_lane"]', card) || {}).textContent),
      clues: qsa('[data-clue-item] strong', card).map(function (node) {
        return clean(node.textContent);
      }).filter(Boolean),
      share_text: attr(card, 'data-social-share-text', '')
    });
  }

  function persistLocalizedResult(payload) {
    var api = window.LittleGResultStorage;
    if (!api || typeof api.saveLocalizedResult !== 'function') return null;
    var checkinRoute = /(?:^|\/)pages\/city-mission\/?$/.test(String(window.location.pathname || ''));
    return api.saveLocalizedResult(
      checkinRoute ? Object.assign({}, payload, { record_type: 'check-in' }) : payload,
      checkinRoute ? 'check-in' : 'mission'
    );
  }

  function sharePayload(card) {
    return {
      title: attr(card, 'data-share-title', 'LittleG'),
      text: attr(card, 'data-social-share-text', 'LittleG'),
      url: window.location.href
    };
  }

  function copyResult(card, button) {
    var payload = sharePayload(card);
    var value = payload.text + ' ' + payload.url;
    announce(card, 'copying', attr(card, 'data-copy-loading-label', ''));

    if (!navigator.clipboard || !navigator.clipboard.writeText) {
      announce(card, 'copy_unsupported', attr(card, 'data-copy-unsupported-label', ''));
      return;
    }

    navigator.clipboard.writeText(value).then(function () {
      button.textContent = attr(card, 'data-copy-success-label', button.textContent);
      card.setAttribute('data-copy-status', 'success');
      announce(card, 'copy_success', attr(card, 'data-copy-success-message', ''));
    }).catch(function () {
      card.setAttribute('data-copy-status', 'failed');
      announce(card, 'copy_failed', attr(card, 'data-copy-failed-label', ''));
    });
  }

  // Keep the canonical SVG stable when Save progresses through loading/success/error.
  // The fallback supports older instances that only contain button text.
  function setResultActionLabel(button, value) {
    var label = qs('[data-result-action-label]', button);
    var next = String(value == null ? '' : value);
    if (label) label.textContent = next;
    else button.textContent = next;
    button.setAttribute('aria-label', next);
  }

  function saveResult(card, button) {
    var label = qs('[data-result-action-label]', button);
    var original = label ? label.textContent : button.textContent;
    button.disabled = true;
    setResultActionLabel(button, attr(card, 'data-save-loading-label', original));
    announce(card, 'saving', attr(card, 'data-save-loading-label', ''));

    var saved = persistLocalizedResult(payloadFromCard(card));
    card.setAttribute('data-status', saved ? 'saved' : 'save_failed');
    card.setAttribute('data-saved-result-id', clean(saved && (saved.result_id || saved.record_id || saved.card_id)));
    setResultActionLabel(button, saved
      ? attr(card, 'data-save-success-label', original)
      : attr(card, 'data-save-failed-label', original));
    button.disabled = !!saved;
    button.setAttribute('aria-disabled', saved ? 'true' : 'false');
    announce(
      card,
      saved ? 'save_success' : 'save_failed',
      saved ? attr(card, 'data-save-success-message', '') : attr(card, 'data-save-failed-message', '')
    );
    hydrate(card);
  }

  function shareResult(card) {
    var payload = sharePayload(card);
    announce(card, 'sharing', attr(card, 'data-share-loading-label', ''));

    if (!navigator.share) {
      var copyButton = qs('[data-copy-challenge]', card);
      if (copyButton) copyResult(card, copyButton);
      return;
    }

    navigator.share(payload).then(function () {
      card.setAttribute('data-share-status', 'shared');
      announce(card, 'share_success', attr(card, 'data-share-success-message', ''));
    }).catch(function (error) {
      var cancelled = error && error.name === 'AbortError';
      card.setAttribute('data-share-status', cancelled ? 'cancelled' : 'failed');
      announce(
        card,
        cancelled ? 'share_cancelled' : 'share_failed',
        attr(card, cancelled ? 'data-share-cancelled-message' : 'data-share-failed-message', '')
      );
    });
  }

  function bind(card) {
    if (!card || card.dataset.resultCardRuntimeReady === VERSION) return;
    card.dataset.resultCardRuntimeReady = VERSION;
    card.dataset.resultCardInteractionOwner = 'assets/littleg-result-card-runtime.js';

    var save = qs('[data-finish-save]', card);
    var share = qs('[data-share-mission-card]', card);
    var copy = qs('[data-copy-challenge]', card);

    if (save) save.addEventListener('click', function (event) {
      ownAction(event);
      saveResult(card, save);
    });
    if (share) share.addEventListener('click', function (event) {
      ownAction(event);
      if (!share.disabled) shareResult(card);
    });
    if (copy) copy.addEventListener('click', function (event) {
      ownAction(event);
      if (!copy.disabled) copyResult(card, copy);
    });

    try {
      card.__littleGResultObserver = new MutationObserver(function () {
        hydrate(card);
      });
      card.__littleGResultObserver.observe(card, {
        attributes: true,
        attributeFilter: ['hidden', 'aria-hidden']
      });
    } catch (_) {}

    hydrate(card);
  }

  function boot(scope) {
    qsa(ROOT_SELECTOR, scope || document).forEach(bind);
  }

  window.addEventListener('littleg:mission-state', function (event) {
    var detail = event && event.detail && typeof event.detail === 'object' ? event.detail : {};
    qsa(ROOT_SELECTOR).forEach(function (card) {
      card.__littleGMissionState = detail;
      hydrate(card);
    });
  });

  document.addEventListener('littleg:hydrate-result-card', function (event) {
    var card = event.target && event.target.closest ? event.target.closest(ROOT_SELECTOR) : null;
    if (card) hydrate(card);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
})(window, document);